import React, { Component } from "react";
import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink
} from "reactstrap";


import AccountProfile from "../components/Account/Profile";
import AccountPassword from "../components/Account/Password";


class Account extends Component{

    constructor(props){
        super(props);
        this.toggleTab = this.toggleTab.bind(this);
        this.state = {
            openedTab: "1"
        };
    }

    toggleTab(tab_index){
        if(tab_index !== this.state.openedTab)
            this.setState({openedTab: tab_index});
    }

    render(){
        return (
            <div className="no-padding">
                <Nav tabs className="header-tabs">
                    <NavItem>
                        <NavLink
                            className={ this.state.openedTab === "1" ? "active" : "" }
                            onClick={() => { this.toggleTab('1'); }}
                        >
                            Informations personnelles
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={ this.state.openedTab === "2" ? "active" : "" }
                            onClick={() => { this.toggleTab('2'); }}
                        >
                            Mot de passe
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.openedTab} className="header-tabs pad-30">
                    <TabPane tabId="1">
                        <AccountProfile />
                    </TabPane>
                    <TabPane tabId="2">
                        <AccountPassword />
                    </TabPane>
                </TabContent>
            </div>
        )
    }

}


export default Account;



// WEBPACK FOOTER //
// ./src/views/Account.js